import React, { memo } from 'react';
export function DetailedTestimonials() {
  return <section className="py-12 bg-gray-50 rounded-lg" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 mb-10" data-id="element-38">
          Real Stories from Aya Caps Users
        </h2>
        {/* Testimonial 1 */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8 border-l-4 border-green-500" data-id="element-39">
          <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-40">
            "I didn't even realize how numb I'd become until the fog started
            lifting."
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-41">— Emily R., 54, Chicago</p>
          <p className="text-gray-800 mb-4" data-id="element-42">
            I started Aya Caps not expecting much. I've tried everything over
            the years—SSRIs, therapy, meditation retreats. I functioned, but
            everything felt muted. A few weeks into taking Aya Caps, I noticed I
            wasn't bracing for the day anymore. It was like parts of
            me—feelings, memories, even creativity—were slowly thawing. I
            started writing again. I actually laughed, deeply, not the polite
            kind. I didn't realize how long it had been since I felt alive and
            not just surviving. These capsules didn't make me trip. They made me
            feel like me again.
          </p>
        </div>
        {/* Testimonial 2 */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8 border-l-4 border-green-500" data-id="element-43">
          <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-44">
            "After 20 years of trauma therapy, something finally clicked."
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-45">— Mark D., 61, Oregon</p>
          <p className="text-gray-800 mb-4" data-id="element-46">
            I've done the work. EMDR, somatic experiencing, group therapy. And
            while it all helped, I still felt this persistent hum of dread in my
            nervous system—like my body never quite knew it was safe. A friend
            suggested I try Aya Caps. I was skeptical, but I researched the vine
            and saw it had potential. Two months in, the shift is hard to
            describe. My reactivity softened. I can breathe through moments that
            would've sent me spiraling. I don't think these capsules fixed
            me—but I do think they opened the door to healing that was waiting
            all along.
          </p>
        </div>
        {/* Testimonial 3 */}
        <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-green-500" data-id="element-47">
          <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-48">
            "It's like I stopped being afraid of my own emotions."
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-49">— Leila M., 47, Arizona</p>
          <p className="text-gray-800 mb-4" data-id="element-50">
            I've lived with anxiety my whole life. I thought it was just who I
            was. But since taking Aya Caps, I've had moments where I feel the
            anxiety come up—and instead of panicking, I meet it. Like an old
            friend. There's a softness to how I move through life now. A few
            weeks ago, I cried watching the sunset. Not because I was sad. But
            because I felt… present. And that presence used to be so rare for
            me. I'm not cured. But I'm finally relating to myself differently.
            And that changes everything.
          </p>
        </div>
      </div>
    </section>;
}